"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _OverlayResultsInterface = _interopRequireDefault(require("draft-plugins/components/overlay/OverlayResultsInterface"));

var _UITypeaheadResults = _interopRequireDefault(require("UIComponents/typeahead/results/UITypeaheadResults"));

var _default = function _default(TokenResultItem, TokenResultZeroState) {
  return (0, _createReactClass.default)({
    propTypes: _OverlayResultsInterface.default,
    handleCancel: function handleCancel() {
      var _this$props = this.props,
          onCancel = _this$props.onCancel,
          offset = _this$props.offset,
          length = _this$props.length;
      onCancel({
        offset: offset,
        length: length
      });
    },
    handleSelect: function handleSelect(option) {
      var _this$props2 = this.props,
          onSelect = _this$props2.onSelect,
          offset = _this$props2.offset,
          length = _this$props2.length;
      onSelect(option, {
        offset: offset,
        length: length
      });
    },
    renderResults: function renderResults() {
      var _this = this;

      var _this$props3 = this.props,
          results = _this$props3.results,
          search = _this$props3.search,
          selection = _this$props3.selection,
          toggleForcedOverlayFocus = _this$props3.toggleForcedOverlayFocus;

      if (results.length === 0) {
        return _react.default.createElement(TokenResultZeroState, {
          search: search,
          onCancel: this.handleCancel,
          onSelect: this.handleSelect,
          toggleForcedOverlayFocus: toggleForcedOverlayFocus
        });
      }

      return results.slice(0, 5).map(function (option, index) {
        var highlighted = selection === index;
        return _react.default.createElement(TokenResultItem, {
          key: option.value,
          option: option,
          highlighted: highlighted,
          onMouseDown: _this.handleSelect
        });
      });
    },
    render: function render() {
      return _react.default.createElement(_UITypeaheadResults.default, {
        className: "token-results"
      }, this.renderResults());
    }
  });
};

exports.default = _default;
module.exports = exports.default;